import dashboard from '@Dashboard/router'

dashboard.meta.bottomLine = true

export default dashboard
